import { useContext } from 'react';
import { CartContext } from '../Components/shopping/CartContext';
import type { CartContextType } from '../Components/shopping/types';

export const useCart = () => {
  const context = useContext(CartContext) as CartContextType | null;

  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }

  return context;
};
